var render = function () {
  var _vm$dataModel$service, _vm$dataModel$startTi, _vm$dataModel$branchF;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-3 liff-reservation-detail"
  }, [_c('b-card', {
    staticClass: "mb-3 wizard-mode-layout__card",
    attrs: {
      "header-tag": "header"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('h6', {
          staticClass: "mb-0"
        }, [_vm._v("預約人資訊")])])];
      },
      proxy: true
    }])
  }, [_c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "姓名",
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm.user.mobile_phone ? _c('b-form-group', {
    attrs: {
      "label": "電話",
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.user.mobile_phone))])]) : _vm._e()], 1), _c('b-card', {
    staticClass: "mb-3 wizard-mode-layout__card",
    attrs: {
      "header-tag": "header"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('h6', {
          staticClass: "mb-0"
        }, [_vm._v("預約資訊")])])];
      },
      proxy: true
    }])
  }, [_vm.selectedServices.length ? _c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": (_vm$dataModel$service = _vm.dataModel.serviceField) === null || _vm$dataModel$service === void 0 ? void 0 : _vm$dataModel$service.title,
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.selectedServices.map(function (service) {
    return service.title;
  }).join(', ')))])]) : _vm._e(), _vm.selectedStaff.name ? _c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "服務人員",
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.selectedStaff.name))])]) : _vm._e(), _c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": (_vm$dataModel$startTi = _vm.dataModel.startTimeField) === null || _vm$dataModel$startTi === void 0 ? void 0 : _vm$dataModel$startTi.title,
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.selectedScheduleLabel))])]), _vm.endDateTimeForDisplay && !_vm.dataModel.shouldHideEndTime ? _c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "預約結束時間",
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.endDateTimeForDisplay.format(_vm.dataModel.startAtFieldFormatIsDate ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm')))])]) : _vm._e(), _vm.selectedBranch.name ? _c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": (_vm$dataModel$branchF = _vm.dataModel.branchField) === null || _vm$dataModel$branchF === void 0 ? void 0 : _vm$dataModel$branchF.title,
      "label-cols": "4",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label-for": "input-sm"
    }
  }, [_c('div', {
    staticClass: "text-right s-text-sm"
  }, [_vm._v(_vm._s(_vm.selectedBranch.name))])]) : _vm._e()], 1), _vm.fields.length > 0 ? _c('b-card', {
    staticClass: "mb-3 wizard-mode-layout__card",
    attrs: {
      "header-tag": "header"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('h6', {
          staticClass: "mb-0"
        }, [_vm._v("其他資訊")])])];
      },
      proxy: true
    }], null, false, 2103930379)
  }, _vm._l(_vm.fields, function (field) {
    return _c('b-form-group', {
      key: field._id,
      staticClass: "mb-3",
      attrs: {
        "label": field.title,
        "label-cols": "4",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label-for": "input-sm"
      }
    }, [_c('div', {
      staticClass: "text-right s-text-sm"
    }, [_vm._v(_vm._s(_vm.extraFormData[field._id]))])]);
  }), 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }